import React from 'react';

import styles from 'common/components/ShowtimeModal/styles.module.scss';

const QuickInfo = ({ info }: { info?: string }) =>
  info && info.length ? <span className={styles.quickInfo}>{info}</span> : null;

export default QuickInfo;
